import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BusinessConfigurationForm } from '../../../types/business/BusinessTypes';

interface BusinessConfigState {
  form: BusinessConfigurationForm;
  isLoading: boolean;
  isSubmitting: boolean;
  error: string | null;
}

const initialState: BusinessConfigState = {
  form: {
    id: null,
    businessName: '',
    phoneNumber: '',
    nit: '',
    nrc: '',
    email: '',          // 🔥 NUEVO CAMPO para el correo
    logoPath: '',       // ✅ Logo para ticket
    pdfLogoPath: '',    // 🔥 Logo para documentos PDF (nuevo campo)
    headerText: '',
    footerText: '',
    taxpayerName: '',
    taxpayerCategoryId: null,
    taxpayerCategoryName: '',
    economicActivityId: null,
    economicActivityName: '',
  },
  isLoading: false,
  isSubmitting: false,
  error: null,
};



const businessConfigSlice = createSlice({
  name: 'businessConfig',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setSubmitting(state, action: PayloadAction<boolean>) {
      state.isSubmitting = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setBusinessConfig(state, action: PayloadAction<BusinessConfigurationForm>) {
      state.form = action.payload;
      state.error = null;
    },
    updateBusinessField(
      state,
      action: PayloadAction<{ field: keyof BusinessConfigurationForm; value: any }>
    ) {
      const { field, value } = action.payload;
      state.form = {
        ...state.form,
        [field]: value,
      };
    },
    resetBusinessConfig(state) {
      state.form = initialState.form;
      state.isSubmitting = false;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setSubmitting,
  setError,
  setBusinessConfig,
  updateBusinessField,
  resetBusinessConfig,
} = businessConfigSlice.actions;

export default businessConfigSlice.reducer;
